import styled from 'styled-components';
import { GrantsTable } from '../../style';

export const CustomTable = styled(GrantsTable)`
.ant-table-thead > tr > th {
    padding: 17px 0px 21px 20px !important;
}
border-top: 1px solid ${props => props.theme.border.primary};
margin-top: 20px
`;

export const GrantAllocationFooter =styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.headingColor};
  border-top: 1px solid ${props => props.theme.colors.border};
  border-bottom: 1px solid ${props => props.theme.colors.border};
  margin-bottom: 3rem;
  word-break: break-word;
  @media only screen and (min-width: 992px) {
    font-size: ${props => props.theme.fontSize.primary};
    margin-bottom: 50px;
  }
  .ant-col {
    padding: 20px 0px 20px 20px;
    @media only screen and (max-width: 991px) {
      &:last-child {
        padding-right: 0px;
      }
      &:first-child {
        padding-left: 0px;
      }
    }
  }
  .content{
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.secondary};
    color: ${props => props.theme.fontColors.thead};
    @media only screen and (min-width: 992px) {
      font-size: ${props => props.theme.fontSize.primary};
    }
  }
`;

export const NoWrapLabel = styled.span`
  white-space: nowrap;
`;

export const AllSharesAllPoolsHeader = styled.div`
  padding-left: 10px;
  span {
    display: inline-block;
  }
`;